import { getUserData } from "Application/User/UserService";
import ProfileStatus from "./ProfileStatus";
import ProfileForm from "./ProfileForm";
import { useParams } from "react-router-dom";
import { User, UserEntity } from "Domain/User/Entity/User";
import EntityProvider from "pages/components/Behavior/EntityProvider";
import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import OutlinedFieldDisplay from "pages/components/OutlinedFIeldDisplay";
import DebtorProfileForm from "./DebtorProfileForm";

export default function ProfilePage() {
  const { id = "" } = useParams<string>();
  return (
    <EntityProvider<User> callback={getUserData} params={[id]}>
      {(userData, setUserData) => {
        const userEntity = new UserEntity(userData);
        let userProfilePage;
        if (userEntity.isUserInternal()) {
          userProfilePage = (<InternalUserDisplay userData={userData} />);
        } else if (userEntity.isUserCreditor()) {
          userProfilePage = (
            <ProfileForm
              userData={userData}
              id={id}
              setUserData={setUserData}
            />
          );
        } else {
          userProfilePage = (
            <DebtorProfileForm
              userData={userData}
              id={id}
              setUserData={setUserData}
            />
          );
        }

        return (
          <div>
            <ProfileStatus userData={userData} setUserData={setUserData} />
            {userProfilePage}
          </div>
        );
      }}
    </EntityProvider>
  );
}

type InternalUserDisplayProps = {
  userData: User;
};

function InternalUserDisplay({ userData }: InternalUserDisplayProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box
      display={"flex"}
      flexDirection={isMobile ? "column" : "row"}
      justifyContent={"space-around"}
      paddingTop={15}
    >
      <OutlinedFieldDisplay field="email" value={userData.email} />
      <OutlinedFieldDisplay field="type" value={userData.type} />
      <OutlinedFieldDisplay field="active" value={userData.isVerified} />
      <OutlinedFieldDisplay field="createdAt" value={userData.createdAt} />
    </Box>
  );
}
